import React from "react";
import { Card, Section, TooltipIcon } from "@sscs/ui";
import { ASSESSMENT_SUPERCATEGORY, ASSESSMENT_SUPERCATEGORY_TYPES, } from "../../../constants";
import { AssessmentCategory } from "../../common";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import styles from "./safeAssessment.module.scss";
const Assessment = ({ risk, risksCountWrapper, }) => {
    const anyRiskCategoryDeactivated = Object.values(risk).some((category) => category.enabled === false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card.Content, null,
            React.createElement("div", { className: styles["grid-container"] }, Object.keys(ASSESSMENT_SUPERCATEGORY_TYPES).map((superCategory) => {
                const riskCategories = ASSESSMENT_SUPERCATEGORY_TYPES[superCategory];
                return (React.createElement(Section, { key: superCategory },
                    React.createElement(Section.Title, { as: "h3" }, ASSESSMENT_SUPERCATEGORY[superCategory]),
                    React.createElement(Section.Content, null, riskCategories.map((riskCategory) => (React.createElement(AssessmentCategory, { key: riskCategory, riskCategory: riskCategory, risk: risk[riskCategory], risksCountWrapper: risksCountWrapper }))))));
            }))),
        anyRiskCategoryDeactivated && (React.createElement(Card.Actions, null,
            "Additional categories of the SAFE assessment are available in the\u00A0",
            React.createElement("strong", null, "Spectra Assure Enterprise+"),
            "\u00A0tier."))));
};
const Panel = ({ disabledPoliciesCount, disabledPoliciesCountWrapper, children, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: "Summary of key software safety concerns." }),
            ], actions: React.createElement(RenderChildrenWrapper, { wrapper: disabledPoliciesCountWrapper },
                disabledPoliciesCount.toLocaleString(),
                " policies were disabled") }, "SAFE assessment"),
        children));
};
export default {
    Panel,
    Assessment,
};
//# sourceMappingURL=SafeAssessment.js.map